import React, { useEffect, useState } from "react";
import {
  ResponsiveContainer,
  BarChart,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Bar,
} from "recharts";
import { useTranslation } from "react-i18next";

export default function WeeklyReactiveEnergyChart({ deviceId, API_BASE, refreshKey }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(
          `${API_BASE}/measurements/daily-reactive-energy-history?deviceId=${deviceId}`
        );
        const json = await res.json();
        let history = json.history || [];

        setData(
          history.map(d => ({
            date: d.day.split("T")[0],
            dailyImport: Math.trunc(Number(d.daily_import) * 1000) / 1000,
            dailyExport: Math.trunc(Number(d.daily_export) * 1000) / 1000,

          }))
        );
      } catch {
        setData([]);
      }
    }

    load();
    const int = setInterval(load, 10000);
    return () => clearInterval(int);
  }, [deviceId, API_BASE, refreshKey]);

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5">
      <h3 className="text-sm font-semibold text-slate-700 mb-3">
        {t('dashboard.weeklyReactiveTitle')}
      </h3>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <XAxis dataKey="date" stroke="#6B7280" />
            <YAxis stroke="#6B7280" />
            <Tooltip />
            <Legend wrapperStyle={{ paddingTop: "10px" }} />
            <Bar dataKey="dailyImport" name={t('dashboard.legendImportkVArh')} fill="#3B82F6" />
            <Bar dataKey="dailyExport" name={t('dashboard.legendExportkVArh')} fill="#EF4444" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
